export function asSingleOrderProducts(products) {
    return products.map((p) => ({
        id: p.id,
        price: p.price,
        quantity: p.quantity,
        vatRate: p.vatRate,
    }))
}
